import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import i18next from 'i18next'

import * as styles from './ExtraNotification.module.scss'

import { usePropertyProvider } from '../../../../hooks'
import resources from '../../../../locales'
import { FlexBox, Text, WhiteText } from '../../../basics'

// i18next ParseKeys is available in version 23.0.0 and later.
// After updating to v23.0.0 or later, no longer need to declare
// RecursiveKeyOf type.
type RecursiveKeyOf<T extends object> = {
  [Key in keyof T & (string | number)]: T[Key] extends object
    ? `${Key}.${RecursiveKeyOf<T[Key]>}`
    : `${Key}`
}[keyof T & (string | number)]

type TranslationKeys =
  | RecursiveKeyOf<typeof resources.en.translation>
  | RecursiveKeyOf<typeof resources.ja.translation>

const isValidKey = (
  key: string,
  i18nInstance: typeof i18next
): key is TranslationKeys => i18nInstance.exists(key)

const translateNamespace = 'components.ExtraNotification'

export const ExtraNotification: React.FC = () => {
  const { slug } = usePropertyProvider()
  const { t, i18n } = useTranslation()

  const titleKey = `${translateNamespace}.${slug}.title`
  const bodyKey = `${translateNamespace}.${slug}.body`

  if (!slug || !isValidKey(titleKey, i18n) || !isValidKey(bodyKey, i18n)) {
    return null
  }

  const titleText = t(titleKey)
  return (
    <FlexBox>
      <div className={styles.recommendText}>
        <WhiteText pcSize={20} spSize={14}>
          {titleText}
        </WhiteText>
      </div>
      <div className={styles.recommendation}>
        <Text pcSize={16} spSize={12}>
          <Trans<typeof bodyKey>
            i18nKey={bodyKey}
            components={{
              br: <br />,
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              a: <a target="_blank" rel="noreferrer" className={styles.link} />,
            }}
          />
        </Text>
      </div>
    </FlexBox>
  )
}
